import React from 'react';
import { DraggableTooltipContainer } from 'spw-components/worksheet/styles';
import {
  TooltipTitle,
  TooltipText,
  TooltipSection,
  TooltipBody,
} from './styles';

const GrowthRateGuide: React.FC = () => (
  <DraggableTooltipContainer>
    <TooltipTitle id="draggable-dialog-title" className="title">
      Growth Rate % Tips
    </TooltipTitle>

    <TooltipBody className="content">
      <TooltipSection style={{ marginTop: 0 }}>
        OPTION A: GROWTH RATE
      </TooltipSection>

      <TooltipText>
        Enter current headcount and a growth rate % if your headcount will
        increase annually at the same rate.
      </TooltipText>

      <TooltipText className="secondary">
        NOTE: If headcounts were previously entered without a growth rate, and a
        growth rate is entered, headcounts will recalculate with the new growth
        rate.
      </TooltipText>

      <TooltipSection>OPTION B: NO GROWTH RATE</TooltipSection>

      <TooltipText>
        Enter headcount per year when you do not know the growth rate or if
        headcount growth will vary annually.
      </TooltipText>

      <TooltipText className="secondary">
        NOTE: If headcounts were previously calculated with a growth rate, and
        new headcounts are manually entered, the previous growth rate will clear
        out.
      </TooltipText>
    </TooltipBody>
  </DraggableTooltipContainer>
);

export default GrowthRateGuide;
